export default __webpack_public_path__ + "static/pulizie-condomini-78a7cf002900f480ffe292d29c596c9d.webp";